import { data_center_eu, device_id_key } from 'eco-design-micro/EcoStat/config';
import { getIsPadWidth } from 'eco-design-micro/utils-base/devices';
import { getCookie } from 'eco-design-micro/utils-base/getCookie';
import { getPreviewIdA1 } from 'eco-design-micro/utils-base/getPreviewIdA1';
import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import { useCallback, useEffect, useRef, useState } from 'react';
import './index.scss';

interface WidgetsItemQuestionnaireIprops {
    iconUrl: string;
    show?: () => void;
    hide?: () => void;
    effectUser: string;
    hasContinue: boolean;
    startTime: number;
}
const NEXT_PUBLIC_BH_HOST = process.env.NEXT_PUBLIC_BH_HOST;
const NEXT_PUBLIC_BH_HOST_NA = process.env.NEXT_PUBLIC_BH_HOST_NA;
export default function WidgetsItemQuestionnaire({ iconUrl, show, hide, effectUser, hasContinue, startTime }: WidgetsItemQuestionnaireIprops) {
    const { locale = 'us' } = getLocal();
    const [openA, setOpenA] = useState(false);
    const openKeyQuestionnaireAA1 = 'openKeyQuestionnaireAA1';
    const stat_node_api = data_center_eu.includes(locale) ? NEXT_PUBLIC_BH_HOST : NEXT_PUBLIC_BH_HOST_NA;
    //const isMobile = getIsPadWidth();
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const initHandleA = async () => {
            const headers: any = {};
            headers['Accept'] = 'application/json';
            headers['Content-Type'] = 'application/json';
            let device_id = getCookie(device_id_key);
            if (!device_id) {
                device_id = localStorage.getItem(device_id_key) || '';
            }
            const preview_id = getPreviewIdA1();

            let start_time = undefined;
            if (locale !== 'us') {
                // 往前提10秒，避免新用户用户刚进入页面的 pv 也查到了
                start_time = startTime - 10 * 1000;
            }

            const resA = await fetch(`${stat_node_api}/gtm/common-statistics/web/find-user-exist-by-device-id-time-a1`, {
                method: 'post',
                body: JSON.stringify({
                    device_id,
                    preview_id,
                    start_time,
                }),
                headers: headers,
            });
            const dataA = await resA.json();
            const dataB = dataA?.data || false; //true为之前访问过
            localStorage.setItem(openKeyQuestionnaireAA1, dataB ? '1' : '0'); //1为有记录;0为无访问记录
            setOpenA(!dataB);
        };
        const initHandleB = async () => {
            const openKeyQuestionnaireVal = localStorage.getItem(openKeyQuestionnaireAA1);
            if (!openKeyQuestionnaireVal) {
                //没有进行过接口请求
                initHandleA();
            } else if (openKeyQuestionnaireVal === '0') {
                //无访问记录
                setOpenA(true);
            }
        };
        if (effectUser === 'new') {
            const interval = setInterval(() => {
                let device_id = getCookie(device_id_key);
                if (!device_id) {
                    device_id = localStorage.getItem(device_id_key) || '';
                }
                if (device_id) {
                    clearInterval(interval);
                    initHandleB();
                }
            }, 500);
        } else {
            localStorage.removeItem(openKeyQuestionnaireAA1);
            setOpenA(true);
        }
        setIsMobile(getIsPadWidth());
    }, []);

    const autoShownRef = useRef(false);
    const autoHideTimerRef = useRef<number | null>(null);
    const userInteractedRef = useRef(false);
    const hasContinueBaseRef = useRef(false);
    const showRef = useRef(show);
    const hideRef = useRef(hide);
    const hasContinueRef = useRef(hasContinue);

    useEffect(() => {
        showRef.current = show;
    }, [show]);
    useEffect(() => {
        hideRef.current = hide;
    }, [hide]);
    useEffect(() => {
        hasContinueRef.current = hasContinue;
    }, [hasContinue]);

    const clearAutoHideTimer = useCallback(() => {
        if (autoHideTimerRef.current) {
            clearTimeout(autoHideTimerRef.current);
            autoHideTimerRef.current = null;
        }
    }, []);

    const handleUserInteraction = useCallback(() => {
        userInteractedRef.current = true;
        clearAutoHideTimer();
    }, [clearAutoHideTimer]);

    const autoShownStorageKey = 'autoShownQuestionnaireOnce';

    useEffect(() => {
        if (isMobile || !openA) return;
        //已经自动弹出过，不再重复触发
        if (localStorage.getItem(autoShownStorageKey)) return;
        //滑动到第3屏自动出现问卷弹框，且整个生命周期只触发一次
        const screenHeight = window.innerHeight;

        const onScroll = () => {
            const scrollY = window.scrollY;

            if (!autoShownRef.current && scrollY >= screenHeight * 2) {
                autoShownRef.current = true;
                userInteractedRef.current = false;
                hasContinueBaseRef.current = hasContinueRef.current;
                localStorage.setItem(autoShownStorageKey, '1');
                // 先展开图标区域
                window.dispatchEvent(new CustomEvent('widgets-force-expand'));
                // 延迟后再打开弹框，并从此刻起计3秒自动收起
                window.setTimeout(() => {
                    showRef.current?.();
                    autoHideTimerRef.current = window.setTimeout(() => {
                        const newlyStarted = !hasContinueBaseRef.current && hasContinueRef.current;
                        if (!userInteractedRef.current && !newlyStarted) {
                            hideRef.current?.();
                            window.dispatchEvent(new CustomEvent('widgets-force-collapse'));
                        }
                    }, 3000);
                }, 400);
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [isMobile, openA, clearAutoHideTimer]);

    if (!openA) {
        return null;
    }
    return (
        <section
            className={'widgets-WidgetsItemQuestionnaire'}
            onClick={isMobile ? show : undefined}
            onPointerEnter={
                isMobile
                    ? undefined
                    : () => {
                          handleUserInteraction();
                          show?.();
                      }
            }
            onPointerLeave={isMobile ? undefined : hide}
            id="WIDGET_Questionnaire"
        >
            <div className="icon-box WidgetsItem-icon questionnaire-icon">
                <EcoImg className="icon-img" pc={iconUrl}></EcoImg>
            </div>
        </section>
    );
}
